import { Injectable } from '@angular/core';
import {
  NotificationsAdapter,
  TNotification,
  UserActions,
} from '../../../domain/adapters/notifications.adapter';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService implements NotificationsAdapter {
  _userActionSubject$ = new Subject<UserActions>();
  userAction$ = this._userActionSubject$.asObservable();
  _notificationsSubject$ = new Subject<TNotification>();
  notifications$ = this._notificationsSubject$.asObservable();

  notify(notification: TNotification): void {
    this._notificationsSubject$.next(notification);
  }
  updateUserAction(action: UserActions): void {
    this._userActionSubject$.next(action);
  }
}
